import { CheckCircleIcon, MinusCircleIcon, ProhibitIcon, XCircleIcon } from '@phosphor-icons/react'
import { match } from 'ts-pattern'
import { z } from 'zod'
import { Spinner } from '../spinner.tsx'
import * as styles from './activity-step-card.css.ts'

export const ActivityStepStatusSchema = z.enum(['in_progress', 'completed', 'error', 'blocked', 'excluded'])
export type ActivityStepStatus = z.infer<typeof ActivityStepStatusSchema>

export type ActivityStepCardProps = {
  title: string
  description?: string
  status: ActivityStepStatus
}

export const ActivityStepCard: React.FC<ActivityStepCardProps> = ({ title, description, status }) => {
  const icon = match(status)
    .with('in_progress', () => (
      <div className={styles.spinnerContainer} aria-label="In progress" role="status">
        <Spinner size="24" variant="cool" label={`${title} in progress`} />
      </div>
    ))
    .with('completed', () => (
      <div className={styles.iconContainer({ status })} aria-label="Completed" role="status">
        <CheckCircleIcon size={24} weight="light" />
      </div>
    ))
    .with('error', () => (
      <div className={styles.iconContainer({ status })} aria-label="Error" role="status">
        <XCircleIcon size={24} weight="light" />
      </div>
    ))
    .with('blocked', () => (
      <div className={styles.iconContainer({ status })} aria-label="Blocked" role="status">
        <ProhibitIcon size={24} weight="light" />
      </div>
    ))
    .with('excluded', () => (
      <div className={styles.iconContainer({ status })} aria-label="Excluded" role="status">
        <MinusCircleIcon size={24} weight="light" />
      </div>
    ))
    .exhaustive()

  return (
    <div className={styles.card({ status })} role="listitem" aria-label={`${title}: ${status}`}>
      {icon}

      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        {description && <div className={styles.description}>{description}</div>}
      </div>
    </div>
  )
}
